import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import Socials from 'components/bolt/socials/socials';
import { accessNested, joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/movieDetails/movieDetails.sss';

export default class MovieDetails extends BaseComp.default {

	renderExtraDetail() {
		if (this.props.type !== 'home') return;
		const { visible } = this.props;

		return (
			<Socials
				class={joinClasses(s.socials, !visible && s.hide)}
				socials={accessNested(Store.get(), 'appData.header.powsterHeader.follow')}
				key="socials"
			/>
		);
	}
}